"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.OrderDate=void 0;const OrderDate=exports.OrderDate="Order Date:";